// import { useMemo, useState } from "react";
// import { ComposableMap, Geographies, Geography } from "react-simple-maps";
// import { geoEqualEarth } from "d3-geo";
// import { Mail, MapPin, Phone, User } from "lucide-react";

// // ---------------------------------------------------------------------------
// // Data
// // ---------------------------------------------------------------------------

// const WORLD_WIDTH = 800;
// const WORLD_HEIGHT = 450;
// const WORLD_SCALE = 140;

// // Public, no-install-needed topojson world atlas (same one used in the
// // react-simple-maps docs). Swap for a self-hosted file if you'd rather not
// // depend on a CDN at runtime.
// const WORLD_GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// // Same projection settings as <ComposableMap projection="geoEqualEarth" /> below,
// // used here purely to turn [lon, lat] into a percentage {x, y} so the markers
// // can be plain absolute-positioned HTML buttons — same pattern as IndiaMap.
// const projection = geoEqualEarth()
//   .scale(WORLD_SCALE)
//   .translate([WORLD_WIDTH / 2, WORLD_HEIGHT / 2]);

// function toMarkerPercent([lon, lat]) {
//   const [x, y] = projection([lon, lat]);
//   return { x: `${(x / WORLD_WIDTH) * 100}%`, y: `${(y / WORLD_HEIGHT) * 100}%` };
// }

// // `coordinates` is [longitude, latitude]. These are approximate city-level
// // pins (chosen because address/phone/email for these offices are still
// // blank) — swap them out for the exact office coordinates once available.
// const internationalOffices = [
//   {
//     key: "usa",
//     country: "USA",
//     contact: "",
//     address: "",
//     phone: "",
//     email: "",
//     coordinates: [-74.006, 40.7128], // New York
//   },
//   {
//     key: "amsterdam",
//     country: "Amsterdam",
//     contact: "",
//     address: "",
//     phone: "",
//     email: "",
//     coordinates: [4.9041, 52.3676], // Amsterdam
//   },
//   {
//     key: "germany",
//     country: "Germany",
//     contact: "",
//     address: "",
//     phone: "",
//     email: "",
//     coordinates: [13.405, 52.52], // Berlin
//   },
//   {
//     key: "japan",
//     country: "Japan",
//     contact: "",
//     address: "",
//     phone: "",
//     email: "",
//     coordinates: [139.6503, 35.6762], // Tokyo
//   },
//   {
//     key: "london",
//     country: "London (UK)",
//     contact: "",
//     address: "",
//     phone: "",
//     email: "",
//     coordinates: [-0.1276, 51.5072], // London
//   },
// ].map((office) => ({ ...office, marker: toMarkerPercent(office.coordinates) }));

// function mapSearchUrl(address) {
//   return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
// }

// // ---------------------------------------------------------------------------
// // WorldMap — same marker/pointer pattern as IndiaMap (absolute HTML button +
// // ping halo + floating label tag), just wider and backed by a world map.
// // ---------------------------------------------------------------------------

// function WorldMap({ selected, onSelect }) {
//   return (
//     <div
//       className="relative w-[min(100%,420px)] overflow-hidden rounded-[14px] bg-white shadow-[0_16px_36px_rgba(116,35,0,0.15)]"
//       style={{ aspectRatio: `${WORLD_WIDTH} / ${WORLD_HEIGHT}` }}
//     >
//       <ComposableMap
//         projection="geoEqualEarth"
//         projectionConfig={{ scale: WORLD_SCALE }}
//         width={WORLD_WIDTH}
//         height={WORLD_HEIGHT}
//         style={{ width: "100%", height: "100%", display: "block" }}
//       >
//         <Geographies geography={WORLD_GEO_URL}>
//           {({ geographies }) =>
//             geographies.map((geo) => (
//               <Geography
//                 key={geo.rsmKey}
//                 geography={geo}
//                 style={{
//                   default: { fill: "#f7f7f7", stroke: "#b8b8b8", strokeWidth: 0.5, outline: "none" },
//                   hover: { fill: "#ededed", stroke: "#b8b8b8", strokeWidth: 0.5, outline: "none" },
//                   pressed: { fill: "#ededed", stroke: "#b8b8b8", strokeWidth: 0.5, outline: "none" },
//                 }}
//               />
//             ))
//           }
//         </Geographies>
//       </ComposableMap>

//       {internationalOffices.map((office) => {
//         const isActive = office.key === selected.key;

//         return (
//           <button
//             key={office.key}
//             type="button"
//             onClick={() => onSelect(office)}
//             aria-label={`Show ${office.country} office`}
//             className="absolute z-20 flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full transition-transform duration-200 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#d97706]"
//             style={{ left: office.marker.x, top: office.marker.y }}
//           >
//             {isActive && (
//               <span className="absolute h-5 w-5 animate-ping rounded-full bg-[#d97706]/40" />
//             )}
//             <span
//               className={`h-[9px] w-[9px] rounded-full border-2 border-white shadow-[0_6px_12px_rgba(119,61,0,0.24)] transition-all duration-200 ${
//                 isActive ? "scale-110 bg-[#d97706]" : "bg-[#f59e0b]"
//               }`}
//             />
//           </button>
//         );
//       })}

//       <div
//         className="pointer-events-none absolute z-30 whitespace-nowrap rounded-[3px] bg-[#d97706] px-[7px] py-[3px] text-[9px] font-extrabold leading-none text-white shadow-[0_8px_16px_rgba(126,56,0,0.18)]"
//         style={{
//           left: selected.marker.x,
//           top: selected.marker.y,
//           transform: "translate(-50%, calc(-100% - 8px))",
//         }}
//       >
//         {selected.country.toUpperCase()}
//       </div>
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // InternationalOfficeCard — narrowed down a bit so the wider map has room
// // ---------------------------------------------------------------------------

// function InternationalOfficeCard({ office }) {
//   return (
//     <div
//       className="relative w-[min(100%,190px)] flex-1 overflow-y-auto rounded-[14px] bg-gradient-to-br from-[#fb9a08] via-[#e97900] to-[#cb4a00] p-[12px] text-white shadow-[0_16px_36px_rgba(116,35,0,0.15)] sm:p-[14px]"
//       style={{ height: "stretch" }}
//     >
//       <div className="mb-[10px] inline-flex min-h-[26px] items-center justify-center rounded-[8px] bg-white px-[10px] text-center text-[12px] font-bold leading-tight text-[#c67800]">
//         {office.country}
//       </div>

//       <div className="space-y-[8px] text-[11.5px] leading-[1.35] sm:space-y-[9px] sm:text-[15px]">
//         <div className="flex items-start gap-[7px]">
//           <User className="mt-[2px] h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
//           <span>{office.contact || "--"}</span>
//         </div>

//         {office.address ? (
//           <a
//             href={mapSearchUrl(office.address)}
//             target="_blank"
//             rel="noreferrer"
//             className="group flex gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 focus-visible:ring-2 focus-visible:ring-white/80"
//           >
//             <MapPin className="mt-[2px] h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
//             <span className="group-hover:underline">{office.address}</span>
//           </a>
//         ) : (
//           <div className="flex items-start gap-[7px]">
//             <MapPin className="mt-[2px] h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
//             <span>--</span>
//           </div>
//         )}

//         {office.phone ? (
//           <a
//             href={`tel:${office.phone.replace(/[^0-9+]/g, "")}`}
//             className="flex items-center gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 hover:underline focus-visible:ring-2 focus-visible:ring-white/80"
//           >
//             <Phone className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
//             <span>{office.phone}</span>
//           </a>
//         ) : (
//           <div className="flex items-center gap-[7px]">
//             <Phone className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
//             <span>--</span>
//           </div>
//         )}

//         {office.email ? (
//           <a
//             href={`mailto:${office.email}`}
//             className="flex items-center gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 hover:underline focus-visible:ring-2 focus-visible:ring-white/80"
//           >
//             <Mail className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
//             <span>{office.email}</span>
//           </a>
//         ) : (
//           <div className="flex items-center gap-[7px]">
//             <Mail className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
//             <span>--</span>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // International — top-level export, fully self-contained (data + map + card + state)
// // ---------------------------------------------------------------------------

// export default function International() {
//   const [selectedKey, setSelectedKey] = useState("usa");

//   const selectedOffice = useMemo(
//     () => internationalOffices.find((office) => office.key === selectedKey) || internationalOffices[0],
//     [selectedKey]
//   );

//   return (
//     <div className="flex flex-col items-center gap-[10px] sm:flex-row sm:items-start sm:justify-center sm:gap-[10px] lg:justify-start">
//       <WorldMap selected={selectedOffice} onSelect={(office) => setSelectedKey(office.key)} />
//       <InternationalOfficeCard office={selectedOffice} />
//     </div>
//   );
// }



// new code 




import { useMemo, useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { geoEquirectangular } from "d3-geo";
import { Mail, MapPin, Phone, User } from "lucide-react";

// ---------------------------------------------------------------------------
// Data
// ---------------------------------------------------------------------------

const WORLD_WIDTH = 820;
const WORLD_HEIGHT = 520;
const WORLD_SCALE = 125; // Adjusted for equirectangular

const WORLD_GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const projection = geoEquirectangular()
  .scale(WORLD_SCALE)
  .translate([WORLD_WIDTH / 2, WORLD_HEIGHT / 2]);

function toMarkerPercent([lon, lat]) {
  const [x, y] = projection([lon, lat]);
  return { 
    x: `${(x / WORLD_WIDTH) * 100}%`, 
    y: `${(y / WORLD_HEIGHT) * 100}%` 
  };
}

// Good spacing between European cities
const internationalOffices = [
  {
    key: "usa",
    country: "USA",
    contact: "",
    address: "",
    phone: "",
    email: "",
    coordinates: [-74.006, 40.7128],
  },
  {
    key: "amsterdam",
    country: "Amsterdam",
    contact: "",
    address: "",
    phone: "",
    email: "",
    coordinates: [3.5, 53.1],
  },
  {
    key: "germany",
    country: "Germany",
    contact: "",
    address: "",
    phone: "",
    email: "",
    coordinates: [15.2, 51.7],
  },
  {
    key: "japan",
    country: "Japan",
    contact: "",
    address: "",
    phone: "",
    email: "",
    coordinates: [139.6503, 35.6762],
  },
  {
    key: "london",
    country: "London (UK)",
    contact: "",
    address: "",
    phone: "",
    email: "",
    coordinates: [-1.4, 50.6],
  },
].map((office) => ({ ...office, marker: toMarkerPercent(office.coordinates) }));

function mapSearchUrl(address) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

// ---------------------------------------------------------------------------
// WorldMap - Equirectangular Projection
// ---------------------------------------------------------------------------

function WorldMap({ selected, onSelect }) {
  return (
    <div
      className="relative w-[min(100%,420px)] overflow-hidden rounded-[14px] bg-white shadow-[0_16px_36px_rgba(116,35,0,0.15)]"
      style={{ aspectRatio: `${WORLD_WIDTH} / ${WORLD_HEIGHT}` }}
    >
      <ComposableMap
        projection="geoEquirectangular"
        projectionConfig={{ scale: WORLD_SCALE }}
        width={WORLD_WIDTH}
        height={WORLD_HEIGHT}
        style={{ width: "100%", height: "100%", display: "block" }}
      >
        <Geographies geography={WORLD_GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                style={{
                  default: { fill: "#f7f7f7", stroke: "#b8b8b8", strokeWidth: 0.5, outline: "none" },
                  hover: { fill: "#ededed", stroke: "#b8b8b8", strokeWidth: 0.5, outline: "none" },
                  pressed: { fill: "#ededed", stroke: "#b8b8b8", strokeWidth: 0.5, outline: "none" },
                }}
              />
            ))
          }
        </Geographies>
      </ComposableMap>

      {internationalOffices.map((office) => {
        const isActive = office.key === selected.key;

        return (
          <button
            key={office.key}
            type="button"
            onClick={() => onSelect(office)}
            aria-label={`Show ${office.country} office`}
            className="absolute z-20 flex h-8 w-8 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full transition-all duration-200 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#d97706]"
            style={{ left: office.marker.x, top: office.marker.y }}
          >
            {isActive && (
              <span className="absolute h-8 w-8 animate-ping rounded-full bg-[#d97706]/40" />
            )}
            <span
              className={`h-[12px] w-[12px] rounded-full border-2 border-white shadow-[0_6px_12px_rgba(119,61,0,0.24)] transition-all duration-200 ${
                isActive ? "scale-110 bg-[#d97706]" : "bg-[#f59e0b]"
              }`}
            />
          </button>
        );
      })}

      <div
        className="pointer-events-none absolute z-30 whitespace-nowrap rounded-[4px] bg-[#d97706] px-[9px] py-[4px] text-[10px] font-extrabold leading-none text-white shadow-[0_8px_16px_rgba(126,56,0,0.18)]"
        style={{
          left: selected.marker.x,
          top: selected.marker.y,
          transform: "translate(-50%, calc(-100% - 14px))",
        }}
      >
        {selected.country.toUpperCase()}
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// InternationalOfficeCard with Location Buttons
// ---------------------------------------------------------------------------

function InternationalOfficeCard({ office, offices, onSelect }) {
  return (
    <div
      className="relative w-[min(100%,220px)] flex-1 overflow-hidden rounded-[14px] bg-gradient-to-br from-[#fb9a08] via-[#e97900] to-[#cb4a00] p-[14px] text-white shadow-[0_16px_36px_rgba(116,35,0,0.15)]"
      style={{ height: "stretch" }}
    >
      {/* Location Buttons */}
      <div className="mb-4 flex flex-wrap gap-1.5">
        {offices.map((loc) => (
          <button
            key={loc.key}
            onClick={() => onSelect(loc)}
            className={`rounded-full px-3 py-1 text-xs font-semibold transition-all ${
              loc.key === office.key
                ? "bg-white text-[#c67800] shadow-sm"
                : "bg-white/20 hover:bg-white/30 text-white"
            }`}
          >
            {loc.country}
          </button>
        ))}
      </div>

      {/* Current Selected Office Info */}
      {/* <div className="mb-[10px] inline-flex min-h-[26px] items-center justify-center rounded-[8px] bg-white px-[10px] text-center text-[12px] font-bold leading-tight text-[#c67800]">
        {office.country}
      </div> */}

      <div className="space-y-[9px] text-[11.5px] leading-[1.35] sm:text-[15px]">
        <div className="flex items-start gap-[7px]">
          <User className="mt-[2px] h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
          <span>{office.contact || "--"}</span>
        </div>

        {office.address ? (
          <a
            href={mapSearchUrl(office.address)}
            target="_blank"
            rel="noreferrer"
            className="group flex gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 focus-visible:ring-2 focus-visible:ring-white/80"
          >
            <MapPin className="mt-[2px] h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span className="group-hover:underline">{office.address}</span>
          </a>
        ) : (
          <div className="flex items-start gap-[7px]">
            <MapPin className="mt-[2px] h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span>--</span>
          </div>
        )}

        {office.phone ? (
          <a
            href={`tel:${office.phone.replace(/[^0-9+]/g, "")}`}
            className="flex items-center gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 hover:underline focus-visible:ring-2 focus-visible:ring-white/80"
          >
            <Phone className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span>{office.phone}</span>
          </a>
        ) : (
          <div className="flex items-center gap-[7px]">
            <Phone className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span>--</span>
          </div>
        )}

        {office.email ? (
          <a
            href={`mailto:${office.email}`}
            className="flex items-center gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 hover:underline focus-visible:ring-2 focus-visible:ring-white/80"
          >
            <Mail className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span>{office.email}</span>
          </a>
        ) : (
          <div className="flex items-center gap-[7px]">
            <Mail className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span>--</span>
          </div>
        )}
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Main Component
// ---------------------------------------------------------------------------

export default function International() {
  const [selectedKey, setSelectedKey] = useState("usa");

  const selectedOffice = useMemo(
    () => internationalOffices.find((office) => office.key === selectedKey) || internationalOffices[0],
    [selectedKey]
  );

  const handleSelect = (office) => {
    setSelectedKey(office.key);
  };

  return (
    <div className="flex flex-col items-center gap-[16px] sm:flex-row sm:items-start sm:justify-center sm:gap-[20px] lg:justify-start">
      <WorldMap selected={selectedOffice} onSelect={handleSelect} />
      <InternationalOfficeCard 
        office={selectedOffice} 
        offices={internationalOffices} 
        onSelect={handleSelect} 
      />
    </div>
  );
}